import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import i18n from 'i18next';

import Typo from '../../content/components/typo';

import styles from '../styles/uikitManageManagePage.module.scss';

const ManagePage = ({
  actionsComponents = null,
  breadcrumbsBarComponent = null,
  children,
  hasActions = false,
  hasBreadcrumbs = false,
  hasHeadingAccessory = false,
  hasNav = false,
  headingAccessoryClassName = '',
  headingAccessoryComponent = null,
  isProperties = false,
  navComponent = null,
  navItemId = '',
  title = '',
}) => {
  const contents = (
    <div className={styles.contents}>
      {isProperties && hasNav && <div className={styles.nav}>{navComponent}</div>}
      <div
        className={styles.mainContent}
        aria-labelledby={(isProperties && hasNav && navItemId) || undefined}
      >
        {children}
      </div>
    </div>
  );

  return (
    <div className={styles.element}>
      {hasBreadcrumbs && <div className={styles.breadcrumbsBar}>{breadcrumbsBarComponent}</div>}
      <div className={styles.pageHeader}>
        <header className={styles.header}>
          <div className={styles.headingBlock}>
            <Typo element="h1" variant="d04">
              {title}
            </Typo>
            {hasHeadingAccessory && (
              <div className={classnames(styles.headingAccessory, headingAccessoryClassName)}>
                {headingAccessoryComponent}
              </div>
            )}
          </div>
          <div className={styles.actions}>{hasActions && actionsComponents}</div>
        </header>
      </div>
      {isProperties ? (
        <section className={styles.propertiesContent}>
          <header className={styles.propertiesHeader}>
            <Typo element="h2" variant="d02">
              {i18n.t('properties', 'Properties')}
            </Typo>
          </header>
          {contents}
        </section>
      ) : (
        contents
      )}
    </div>
  );
};

ManagePage.propTypes = {
  actionsComponents: PropTypes.arrayOf(PropTypes.node),
  breadcrumbsBarComponent: PropTypes.node,
  children: PropTypes.node.isRequired,
  hasActions: PropTypes.bool,
  hasBreadcrumbs: PropTypes.bool,
  hasHeadingAccessory: PropTypes.bool,
  hasNav: PropTypes.bool,
  headingAccessoryClassName: PropTypes.string,
  headingAccessoryComponent: PropTypes.node,
  isProperties: PropTypes.bool,
  navComponent: PropTypes.node,
  navItemId: PropTypes.string,
  title: PropTypes.string,
};

export default ManagePage;
